/**
 * @generated SignedSource<<fe236b11c109a0a33c1f546442d82e5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AttachmentsQuery$variables = {
  first?: number | null | undefined;
  model_id: string;
  model_type: string;
  page?: number | null | undefined;
};
export type AttachmentsQuery$data = {
  readonly attachments: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"AttachmentFragment">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AttachmentListFragment">;
};
export type AttachmentsQuery = {
  response: AttachmentsQuery$data;
  variables: AttachmentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "model_id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "model_type"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v4 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "model_id",
    "variableName": "model_id"
  },
  {
    "kind": "Variable",
    "name": "model_type",
    "variableName": "model_type"
  },
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AttachmentsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "AttachmentConnection",
        "kind": "LinkedField",
        "name": "attachments",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AttachmentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Attachment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AttachmentFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": (v4/*: any*/),
        "kind": "FragmentSpread",
        "name": "AttachmentListFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "AttachmentsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "AttachmentConnection",
        "kind": "LinkedField",
        "name": "attachments",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AttachmentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Attachment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "extension",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "order",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "created_by",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "filters": [
          "model_type",
          "model_id",
          "page"
        ],
        "handle": "connection",
        "key": "AttachmentFragment_attachments",
        "kind": "LinkedHandle",
        "name": "attachments"
      }
    ]
  },
  "params": {
    "cacheID": "7d1834d6b8432569c54acb4976cd03c3",
    "id": null,
    "metadata": {},
    "name": "AttachmentsQuery",
    "operationKind": "query",
    "text": "query AttachmentsQuery(\n  $model_type: String!\n  $model_id: String!\n  $first: Int\n  $page: Int\n) {\n  attachments(model_type: $model_type, model_id: $model_id, first: $first, page: $page) {\n    edges {\n      cursor\n      node {\n        ...AttachmentFragment\n      }\n    }\n  }\n  ...AttachmentListFragment_JcJL7\n}\n\nfragment AttachmentConnectionFragment on AttachmentConnection {\n  edges {\n    cursor\n    node {\n      order\n      ...AttachmentFragment\n    }\n  }\n  pageInfo {\n    ...PageInfoFragment\n  }\n}\n\nfragment AttachmentFragment on Attachment {\n  id\n  name\n  extension\n  url\n  order\n  created_by\n}\n\nfragment AttachmentListFragment_JcJL7 on Query {\n  attachments(model_type: $model_type, model_id: $model_id, page: $page, first: $first) {\n    edges {\n      cursor\n      node {\n        id\n        ...AttachmentFragment\n        __typename\n      }\n    }\n    ...AttachmentConnectionFragment\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment PageInfoFragment on PageInfo {\n  count\n}\n"
  }
};
})();

(node as any).hash = "2bc4fa31668a8ad90b4511e13feab333";

export default node;
